import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listing-detail-two',
  templateUrl: './listing-detail-two.component.html',
  styleUrls: ['./listing-detail-two.component.css']
})
export class ListingDetailTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
